var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/heart-filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.165 2c-1.6 0-3.1.65-4.2 1.8-1.1-1.1-2.6-1.8-4.2-1.8-.2 0-.35 0-.55.05-2.5.25-4.65 2.15-5.4 4.75-2.1 7 6.9 12.6 9.5 14.5.15.1.4.2.65.2s.5-.1.7-.25c2.6-1.9 11.6-7.5 9.5-14.5-.8-2.6-2.95-4.5-5.4-4.75h-.6z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.cdace720ac157538abc40ea936629b73.svg";
export { ForwardRef as ReactComponent };